// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductList_wrapper__MdEky","productList":"ProductList_productList__D2LgU","paginationButton":"ProductList_paginationButton__AMsls"};